module.exports = __webpack_public_path__ + "img/slideVerify_03.e0c28094.png";